<template>
  <div>
    <iframe
      id="isfScore"
      width="100%"
      height="154"
      frameborder="0"
      scrolling="no"
      :src="
        'https://widgets.sofascore.com/embed/attackMomentum?id=' +
        $route.params.idEvento +
        '&widgetBackground=White'
      "
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Sofascore2",
  components: {},
  props: {},
  methods: {},
  mounted() {
    document.body.style.backgroundColor = "black";
  },
};
</script>

<style scoped>
#isfScore {
  width: 100%;
  border: none;
  position: relative;
  top: 0px;
  height: 300px;
}
</style>